'use client'

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        debug: false,
        load: 'languageOnly',
        interpolation: {
            escapeValue: false,
        },
        detection: {
            order: ['querystring', 'cookie', 'localStorage', 'sessionStorage'],
        },
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json',
            queryStringParams: { v: '1760000000' }
        }
    })

// Add Arabic language class for text alignment
i18n.on('languageChanged', (lng) => {
    if (lng === 'ar') {
        document.body.classList.add('lang-arabic')
    } else {
        document.body.classList.remove('lang-arabic')
    }
})

export default i18n
